export default __webpack_public_path__ + "static/media/highq.eb9ec1b8.jpg";